export const JOB_OFFER_UPDATED = 'job-offer-updated'
export const JOB_OFFER_RESPONSE_UPDATED = 'job-offer-response-updated'
export const JOB_REVIEW_ADDED = 'job-review-added'
